

















































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";

import role, { features, roles } from "@/config/roles";

import { getTimeSince } from "@/utils/date-helpers";
import { sortByDesc } from "@/utils/sort-helpers";

/**
 * Components
 */
import InvitePeopleDialog from "./components/InvitePeopleDialog.vue";

/**
 * API
 */
import teamsAPI from "@/api/teams";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";

/**
 * Types
 */

/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Team members page.
 */
@Component({
	components: {
		DataFetcher,
		InvitePeopleDialog
	}
})
export default class TeamMembersPage extends Vue {
	$refs!: {
		invitePeopleDialog: InvitePeopleDialog;
	};

	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	roles = roles;
	role = role;

	getTimeSince = getTimeSince;


	/// Attributes
	isLoading = false;
	teamMembers: any[] | null = null;
	// Pagination
	page = 1;
	pageCount = 0;
	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	get displayedTeamMembers(): any[] | null {
		if (this.teamMembers == null) {
			return null;
		}
		return this.teamMembers;
		// return this.teamMembers.map((c: any) => ({
		// 	...c,
		// 	guildRank: (c.guildRank == null || !c.isInGuild) ? 100 : c.guildRank
		// }));
	}

	get headers() {
		const headers: any[] = [{
			text: this.$t("user.member"),
			value: "battleTag",
			align: "left",
			sortable: false
		}];

		for (const key of this.rolesToDisplay) {
			if ((roles as any)[key] !== 2) {
				headers.push({
					text: this.$t(`user.permissions.${key}`),
					value: key,
					align: "left"
				});
			}
		}

		headers.push({
			text: this.$t("user.is_approved"),
			value: "isApproved",
			align: "left",
			class: "collapsing"
		});

		headers.push({
			text: "",
			value: "kick",
			align: "center",
			class: "collapsing",
			sortable: false
		});

		return headers;
	}

	get rolesToDisplay() {
		let rolesKeys = Object.keys(roles);
		if (!this.hasFeaturePermission(features.DISCORD)) {
			rolesKeys = rolesKeys.filter(x => (roles as any)[x] != roles.MANAGE_DISCORD);
		}
		return rolesKeys;
	}

	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchTeamMembers();
	}

	getSlotName(key: string) {
		return `item.${key}`;
	}

	async fetchTeamMembers() {
		const teamMembers = await teamsAPI.getTeamMembers(this.currentTeam.id);
		const oldTeamMembers = this.teamMembers;
		this.teamMembers = teamMembers.map((tm) => {
			const res = tm;
			if (oldTeamMembers) {
				res.order = oldTeamMembers.find(x => x.userID == tm.userID).order;
			}
			else {
				const isAdministrator = role(tm.permissions).hasPermission(roles.ADMINISTRATOR);
				const nbPermissions = parseInt(tm.permissions, 10).toString(2).match(/1/g);
				if (!isAdministrator) {
					res.order = nbPermissions ? nbPermissions.length : 0;
				}
				else {
					res.order = Number.MAX_SAFE_INTEGER;
				}
			}

			for (const key of Object.keys(roles)) {
				res[key] = role(tm.permissions).hasPermission((roles as any)[key]);
			}
			return res;
		});
		this.teamMembers = this.teamMembers.sort(sortByDesc(x => x.order));
	}

	async handleToggleApprovedClick(userID: any) {
		this.isLoading = true;
		try {
			await teamsAPI.toggleApprovedMember(this.currentTeam.id, userID);
		} catch (error) {
			this.handleAPIError(error);
		}

		try {
			await this.fetchTeamMembers();
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleTogglePermissionClick(userID: any, permissionCode: number) {
		this.isLoading = true;
		try {
			await teamsAPI.togglePermissionMember(this.currentTeam.id, userID, permissionCode);
		} catch (error) {
			this.handleAPIError(error);
		}

		try {
			await this.fetchTeamMembers();
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}


	async handleKickClick(userID: any) {
		const answer = window.confirm("Do you really want to kick this member ?");
		if (!answer) {
			return;
		}

		this.isLoading = true;
		try {
			await teamsAPI.kickMember(this.currentTeam.id, userID);
			await this.fetchTeamMembers();
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}


	async handleOpenInvitePeopleClick() {
		await this.$refs.invitePeopleDialog.open();
	}

	async handleAfterInvitePeople() {
		await this.fetchTeamMembers();
	}
}
